//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import { SeriesAreaOptions } from 'highcharts';

import { YouTubeStatBubbleDefinitionBase } from '@youtube/youtubeConstants';

export const YouTubeAudienceStatBubbleTitles = {
  changeInSubscribers: 'Change in Subscribers',
};

const OVER_THE_SELECTED_TIME_PERIOD = ' over the selected time period.';

export const YouTubeAudienceStatBubbleTooltips = {
  changeInSubscribers: `${YouTubeStatBubbleDefinitionBase.changeInSubscribers}${OVER_THE_SELECTED_TIME_PERIOD}`,
};

export const YouTubeAudienceChartTooltips = {
  AUDIENCE_AGES: 'Current age distribution of viewers.',
  AUDIENCE_GENDER: 'Current gender distribution of viewers.',
  AUDIENCE_COUNTRIES: 'Current country distribution of viewers.',
};

export const YouTubeAudienceBreakdownTitles = {
  AUDIENCE_AGES: 'Viewers by Age',
  AUDIENCE_GENDER: 'Viewers by Gender',
  AUDIENCE_COUNTRIES: 'Views by Country',
};

export const SUBSCRIBERS_BY_LOCATION_LIMIT = 10;

export const BASE_CHART_HEIGHT = 350;
export const BASE_CHART_WIDTH = 900;

export const BASE_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    height: BASE_CHART_HEIGHT,
    width: BASE_CHART_WIDTH,
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.white,
  },
  series: [
    {
      turboThreshold: 0,
      color: theme.colors.blue2,
    },
  ] as SeriesAreaOptions[],
};

export const getGenderColor = (gender: string) => {
  switch (gender) {
    case 'male':
      return theme.colors.blue3;
    case 'female':
      return theme.colors.blue2;
    default:
      return theme.colors.blue1;
  }
};

export const YOUTUBE_NOT_ENOUGH_SUBSCRIBERS_TOOLTIP =
  'Not enough online subscriber data available.';

export const YOUTUBE_API_DATE_FORMAT = 'YYYY MM DD';
